/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import { agent } from 'components/Header/Header';
import { Agent } from 'components/Header/Header';
import CalendarModal from '../components/CalendarModal';
import MatchedVisasDesktop from 'views/UserDashboard/UserDashboardV4/components/MatchedVisasDashboard/Dashboard-v4/MatchedVisasDashboard-Desktop-v4';
import LearnMoreModal from './components/LearnMoreModal/LearnMoreModal';
import HoldTightModal from './components/HoldTightModal/HoldTightModal';
import HowItWorksButton from './components/HowItWorksButton/HowItWorksButton';
import SupportSection from './components/SupportSection/SupportSection';
import Certificates from './components/Certificates/Certificates';
import Confetti from './components/Confetti/Confetti';
import { useEffect, useRef, useState } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';
import { isEmptyObject } from '../../../utils/isEmptyObject';
import { shallowEqual } from '../../../utils/shallowEqual';
import api from 'api';
import { useAuth } from 'contexts/ProtectedRoute';
import ROLE from '../../../assets/userRoles.json';
import VideoModal from '../components/VideoModal';
import { AppDispatch, RootState } from 'redux/store';
import styles from './UserDashboardV4.module.scss';
import { useOnScreen } from 'hooks/useOnScreen';
import { ctaButtonSlice } from '../../../redux/calculatedData/ctaButton';
import fourStepProcess from 'assets/images/four-step-process.png';
import fourStepProcessMobile from 'assets/images/four-step-process-mobile.png';
import ColorfulBtn from './components/BookACallButton/colorfulBtn';
import Footer from 'components/Footer/Footer';
import { useWindowSize } from 'hooks/useWindowSize';
import { Service } from 'api/models/Service';
import * as React from 'react';
import CountUp from 'react-countup';
import MatchedVisasDashboardMobileE1 from 'views/UserDashboard/UserDashboardV4/components/MatchedVisasDashboard/Experiment-1/MatchedVisasDashboardMobileE1';
import CustomerTestimonials from 'views/UserDashboard/UserDashboardV4/components/MatchedVisasDashboard/Experiment-1/CustomerTestimonials';
import BenefitsSection from './components/MatchedVisasDashboard/Experiment-1/BenefitsSection';
import Disclaimer from '../components/Disclaimer';

export default function UserDashboard_V4() {
    const location = useLocation();
    const source = location.state?.source;
    const [isHoldTightModalOpen, setHoldTightModalOpen] = useState<boolean>(
        source === 'confirmationModal'
    );
    const [confetti, setConfetti] = useState(false);
    const [highestScore, setHighestScore] = useState(0);
    const [isVideoModalOpen, setVideoModalOpen] = useState<boolean>(false);
    const [assessmentScore, setAssessmentScore] = useState<any[]>([]);
    const { role } = useAuth();
    const academic_consultation = role === ROLE.academicConsultation;
    const notQualified_consultation = role === ROLE.unqualified;
    const user = useSelector((state: RootState) => state.user.entity, shallowEqual);
    const [userCount, setUserCount] = useState<number | undefined>(undefined);
    const [topAgents, setTopAgents] = useState<any[]>([]);
    const [topAgentsAll, setTopAgentsAll] = useState<any>();
    const [selectedAgent, setSelectedAgent] = useState<Agent>(agent);
    const [selectedCountry, setSelectedCountry] = useState<string>('');
    const [scheduleUrl, setScheduleUrl] = useState<string | null>(null);
    const [isCalendarModalOpen, setCalendarModalOpen] = useState<boolean>(false);
    const [isLearnMoreModalOpen, setlearnMoreModalOpen] = useState<boolean>(false);
    const [isQualifiedBothCountries, setIsQualifiedBothCountries] = useState<boolean>(true);
    const {
        email: userEmail,
        firstname: userFirstname,
        lastname: userLastname,
    } = useSelector((state: RootState) => state.user.entity);
    const [matchedVisasModalOpen, setmatchedVisasModalOpen] = useState<boolean>(false);
    const [countTo, setCountTo] = useState<number>(0);

    const handleCalendlySchedule = async (id: number) => {
        try {
            const response = await api.calendar.get(id);
            if (response.status !== 200) {
                alert('Error getting calendar URL.');
                return false;
            }
            setScheduleUrl(response.data['url']);
        } catch (error) {
            console.error(error);
        }
    };

    // set selected country for modal depending on the country of the randomly selected service provider
    useEffect(() => {
        setSelectedCountry(selectedAgent.country);
    }, [selectedAgent]);

    useEffect(() => {
        if (!academic_consultation) fetchBestScoreAgents();
        // eslint-disable-next-line
    }, [user.role]);

    const fetchBestScoreAgents = async () => {
        try {
            const res = await api.assessmentTopPicks.get();
            setTopAgentsAll(res.data);

            const tmpAUS = res.data.Australia ? res.data.Australia : [];
            const tmpCAN = res.data.Canada ? res.data.Canada : [];
            const tmpAgents = tmpAUS.concat(tmpCAN);
            setTopAgents(tmpAgents);
            setIsQualifiedBothCountries(tmpAUS.length && tmpCAN.length);
            // setTopAgents(res.data.Australia.concat(res.data.Canada));
        } catch (e) {
            console.error(e);
        }
    };

    const handleCanada = () => {
        setSelectedCountry('Canada');
        setTopAgents(topAgentsAll['Canada']);
    };

    const handleAustralia = () => {
        setSelectedCountry('Australia');
        setTopAgents(topAgentsAll['Australia']);
    };

    useEffect(() => {
        if (topAgents && topAgents.length > 0) {
            const randomIndex = Math.floor(Math.random() * topAgents.length);
            setSelectedAgent(topAgents[randomIndex]);
        }
    }, [topAgents]);

    useEffect((): void => {
        const fetchBestScoreAssessmentResults = async () => {
            try {
                let res;
                if (user.id) {
                    res = await api.assessment.getTopScore(user.id);
                }

                if (!isEmptyObject(res) && res?.data) {
                    setAssessmentScore(res.data);
                }
            } catch (e) {
                console.error(e);
            }
        };

        fetchBestScoreAssessmentResults();
    }, [user]);

    const isAssessmentScoreEmpty = () => {
        return highestScore === undefined || highestScore === 0;
    };

    useEffect((): void => {
        const fetchUserCount = async (userRole: string) => {
            try {
                const res = await api.userCount.getUserCount(userRole);
                setUserCount(res.data);
            } catch (e) {
                console.error(e);
            }
        };

        fetchUserCount('ACADEMIC_CONSULTATION');
    }, []);

    useEffect((): void => {
        const highestScoreFetcher = () => {
            const scores: number[] = [];
            assessmentScore.forEach((country) => {
                country.eligible_programs.forEach((program: any) => {
                    scores.push(trueScore(program));
                });
            });

            scores.sort((a, b) => {
                if (a < b) {
                    return 1;
                } else if (a > b) {
                    return -1;
                } else {
                    return 0;
                }
            });

            setHighestScore(scores[0]);
        };

        highestScoreFetcher();
    }, [assessmentScore]);

    const trueScore = (item: any): number => {
        const score: number = Math.round((100 * item.summary.score) / item.summary.max_score);

        if (isNaN(score)) {
            return 70;
        }
        return score;
    };

    useEffect(() => {
        ReactGA.send({
            hitType: 'pageview',
            page: `${window.location.pathname}`,
            title: 'UserDashboard',
        });
    }, []);

    const dispatch = useDispatch<AppDispatch>();
    const { url: paymentLink } = useSelector((state: RootState) => state.payment);

    useEffect(() => {
        if (paymentLink) navigateToPaymentSystem(paymentLink);
    }, [paymentLink]);

    const navigateToPaymentSystem = (link: string) => {
        const anchor = document.createElement('a');
        anchor.href = link;
        document.body.append(anchor);
        anchor.setAttribute('style', 'display: none');
        anchor.click();
        anchor.remove();
    };

    const user_id = useSelector((state: RootState) => state.user.entity.id);

    const payVisaFee = async () => {
        try {
            const host = removeHash();
            const res = await api.payments.post({
                product: 'Consultation fee',
                service_id: 5,
                user_id: user_id,
                success_redirect_url: `${host}?paymentWallPassed`,
                fail_redirect_url: `${host}`,
            });
            window.location.href = res.data['url'];
        } catch (e) {
            console.error(e);
        }
    };

    const removeHash = () => {
        const hash = window.location.hash;
        let host;
        if (hash) {
            host = window.location.href.substring(0, window.location.href.indexOf('#'));
        } else {
            host = window.location.href;
        }
        return host;
    };

    const [searchParams] = useSearchParams();
    const paymentWallPassed = searchParams.get('paymentWallPassed');
    const [paywallStatus, setPaywallStatus] = useState<string>('');

    useEffect(() => {
        const fetchData = async () => {
            // const res = await api.payments.paywallStatus();
            // setPaywallStatus(res.data.status);
            setPaywallStatus('PAID');
        };

        fetchData().catch(console.error);
    }, [paymentWallPassed]);

    useEffect(() => {
        if (paywallStatus === 'PAID') {
            if (selectedAgent?.super_admin_id) {
                handleCalendlySchedule(selectedAgent?.super_admin_id);
                openalendarModal();
            }
        }
    }, [paywallStatus, selectedAgent]);
    //check added

    const actionButton = () => {
        if (paywallStatus !== 'PAID') {
            payVisaFee();
        } else {
            openalendarModal();
            handleCalendlySchedule(selectedAgent?.super_admin_id);
        }
    };

    const openalendarModal = () => {
        setCalendarModalOpen(true);
    };
    const openCloseCalendarModal = () => {
        setCalendarModalOpen((prevState) => !prevState);
    };

    const openCloseVideoModal = () => {
        setVideoModalOpen((prevState) => !prevState);
    };

    const openCloseHoldTightModal = () => {
        setHoldTightModalOpen((prevState) => !prevState);
    };

    const openCloseLearnMoreModal = () => {
        setlearnMoreModalOpen((prevState) => !prevState);
    };

    const openCloseMatchedVisasModal = () => {
        setmatchedVisasModalOpen((prevState) => !prevState);
    };

    const videoUrl =
        'https://player.vimeo.com/video/818165398?h=c85e8d5c1c&color=4A55BD&title=0&byline=0&portrait=0';
    const videoTitle = 'Completed assessment video';

    const ref = useRef<HTMLDivElement>(null);
    const { setCtaButton } = ctaButtonSlice.actions;
    const isVisible = useOnScreen(ref);

    useEffect(() => {
        if (!academic_consultation) {
            dispatch(setCtaButton({ display: isVisible }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isVisible]);

    const { display } = useSelector((state: RootState) => state.ctaButton);

    const [width, height] = useWindowSize();
    const [mobile, setMobile] = useState(false);

    useEffect(() => {
        if (width > 510) {
            setMobile(false);
        }
        if (width <= 510) {
            setMobile(true);
        }
    }, [width, height]);

    const [, setServices] = useState<Service[]>([]);

    useEffect(() => {
        (async () => {
            const data = { id: '106' };
            const resServices = await api.services.get(Number(data.id));
            if (resServices.status === 200) {
                setServices(resServices.data['services']);
            }
        })();
    }, []);

    useEffect(() => {
        if (userCount) {
            setCountTo(userCount);
        }
    }, [userCount]);

    return (
        <>
            {isHoldTightModalOpen && (
                <>
                    <HoldTightModal
                        open={isHoldTightModalOpen}
                        closeModal={openCloseHoldTightModal}
                        boomConfetti={setConfetti}
                    />
                </>
            )}
            <div
                className={
                    !academic_consultation ? styles.UserPageContainer : styles.AcademicPageContainer
                }
                style={{
                    filter: isHoldTightModalOpen ? 'blur(6px)' : 'none',
                }}
            >
                {confetti && <Confetti />}
                <div>
                    <div
                        className={styles.MainSection}
                        style={{
                            alignItems: 'center',
                        }}
                    >
                        {!academic_consultation && !notQualified_consultation && (
                            <>
                                <p className={styles.StartNow}>
                                    <span style={{ whiteSpace: 'nowrap' }}>
                                        {userFirstname}, Our Experts Can
                                    </span>{' '}
                                    <span style={{ whiteSpace: 'nowrap' }}>
                                        Turn Your Visa Dream
                                    </span>{' '}
                                    <span style={{ whiteSpace: 'nowrap' }}>Into A Reality!</span>
                                </p>

                                <p className={styles.Congratulations}>
                                    <span style={{ whiteSpace: 'nowrap' }}>
                                        Congratulations! You Have A{' '}
                                        <span
                                            className={`${styles.GreenText} ${
                                                isAssessmentScoreEmpty() ? styles.notFilled : ''
                                            }`}
                                        >
                                            {highestScore}%
                                        </span>
                                    </span>{' '}
                                    <span style={{ whiteSpace: 'nowrap' }}>
                                        Chance Of Getting A Visa,
                                    </span>{' '}
                                    <span style={{ whiteSpace: 'nowrap' }}>
                                        Let Us Help You Get It!
                                    </span>
                                </p>

                                <div ref={ref} className={styles.ButtonContainer}>
                                    <ColorfulBtn payVisaFee={actionButton} />
                                </div>
                                {scheduleUrl && isCalendarModalOpen && (
                                    <CalendarModal
                                        open={isCalendarModalOpen}
                                        onClose={openCloseCalendarModal}
                                        userEmail={userEmail}
                                        userFirstname={userFirstname}
                                        userLastname={userLastname}
                                        scheduleUrl={scheduleUrl}
                                        country={selectedCountry}
                                        isQualifiedBothCountries={isQualifiedBothCountries}
                                        handleCanada={handleCanada}
                                        handleAustralia={handleAustralia}
                                        superAdminId={selectedAgent?.super_admin_id}
                                        handleCalendlySchedule={handleCalendlySchedule}
                                    ></CalendarModal>
                                )}

                                {userCount ? (
                                    <>
                                        <p className={cn(styles.WeveHelped, styles.hideLP)}>
                                            We've Helped{' '}
                                            <span className={styles.GradientText}>
                                                {userCount.toLocaleString()}{' '}
                                            </span>{' '}
                                            <span style={{ whiteSpace: 'nowrap' }}>
                                                People Find Their Visa Pathways
                                            </span>
                                        </p>
                                        <p className={cn(styles.WeveHelpedMobile, styles.showLP)}>
                                            We've Helped{' '}
                                            {countTo && (
                                                <span className={styles.GreenText}>
                                                    <CountUp
                                                        start={0}
                                                        end={userCount}
                                                        duration={15}
                                                        separator=","
                                                    />{' '}
                                                </span>
                                            )}
                                            People*
                                        </p>
                                    </>
                                ) : (
                                    <>
                                        <p
                                            style={{ marginTop: '1rem' }}
                                            className={cn(styles.WeveHelped, styles.hideLP)}
                                        >
                                            Find Your Visa Pathway!
                                        </p>
                                        <p className={cn(styles.WeveHelpedMobile, styles.showLP)}>
                                            Find Your Visa Pathway!
                                        </p>
                                    </>
                                )}

                                {/* <PromotionCoffee
                                    className={cn(styles.largeScreenCoffee, styles.hideLP)}
                                />
                                <div className={cn(styles.smallScreenCoffee, styles.hideLP)}>
                                    <div className={styles.smallCoffeeTextContainer}>
                                        <Coffee1 />
                                        <Coffee2 />
                                    </div>

                                    <Coffee className={styles.coffee} />
                                </div> */}

                                <div className={`flex ${cn(styles.topVisaCard4, styles.hideLP)} `}>
                                    <MatchedVisasDesktop
                                        assessmentScore={assessmentScore}
                                        openCloseLearnMoreModal={openCloseLearnMoreModal}
                                        paid={paywallStatus === 'PAID'}
                                    />
                                </div>
                                <div
                                    className={`flex ${cn(
                                        styles.topVisaCard4Mobile,
                                        styles.showLPE1
                                    )} `}
                                >
                                    <MatchedVisasDashboardMobileE1
                                        assessmentScore={assessmentScore}
                                        handleMatchedVisasClick={openCloseMatchedVisasModal}
                                        matchedVisasModalOpen={matchedVisasModalOpen}
                                        paid={paywallStatus === 'PAID'}
                                        // openCloseLearnMoreModal={openCloseLearnMoreModal}
                                    />
                                </div>

                                <p className={cn(styles.infoParagraphDesktop, styles.hideLP)}>
                                    Reveal your chances of success by getting an{' '}
                                    <span style={{ whiteSpace: 'nowrap' }}>
                                        expert consultation.
                                    </span>
                                </p>

                                <p className={cn(styles.showLP, styles.RefundText)}>
                                    <span style={{ fontSize: '15px' }}>Get </span>
                                    <span
                                        className={styles.GreenTextMobile}
                                        style={{ fontSize: '15px' }}
                                    >
                                        {' '}
                                        2
                                    </span>
                                    <span style={{ fontSize: '15px' }}>
                                        {' '}
                                        consultations for only
                                    </span>
                                    <span
                                        className={styles.GreenTextMobile}
                                        style={{ fontSize: '15px' }}
                                    >
                                        {' '}
                                        $5
                                    </span>
                                    <br />(
                                    <span
                                        className={styles.BoldTextMobile}
                                        style={{ fontSize: '15px' }}
                                    >
                                        Fully refunded{' '}
                                    </span>
                                    once you start the <br />
                                    visa process with us).
                                </p>
                                <p className={cn(styles.promotionDesktop, styles.hideLP)}>
                                    Get
                                    <span className={styles.GreenTextDesktop}> 2</span> expert
                                    consultations for{' '}
                                    <span className={styles.GreenTextDesktop}> $5!</span>
                                    <br />(
                                    <span className={styles.BoldTextDesktop}>Fully refunded </span>
                                    once you start the visa process with us).
                                </p>

                                {mobile && <BenefitsSection />}

                                <LearnMoreModal
                                    open={isLearnMoreModalOpen}
                                    handleClose={openCloseLearnMoreModal}
                                    openCloseVideoModal={openCloseVideoModal}
                                    actionButton={actionButton}
                                />

                                <VideoModal
                                    videoTitle={videoTitle}
                                    videoUrl={videoUrl}
                                    open={isVideoModalOpen}
                                    onClose={openCloseVideoModal}
                                />
                                <span className={styles.hideLP}>
                                    <Certificates />
                                </span>
                                <iframe
                                    className={cn(styles.videoMobile, styles.showLP)}
                                    title="What our experts have to say"
                                    src="https://player.vimeo.com/video/853824120?h=b3d357b647&color=ffffff&title=0&byline=0&portrait=0"
                                    allow="fullscreen"
                                />

                                <div
                                    className={`flex ${cn(
                                        styles.topVisaCard4Mobile,
                                        styles.showLPE1
                                    )} `}
                                >
                                    <CustomerTestimonials />
                                </div>

                                <div className={styles.SimpleProcessContainer4}>
                                    <p className={cn(styles.SimpleProcess4, styles.hideLP)}>
                                        Our Simple
                                        <span className={styles.GradientText}> 4 Step</span> Visa
                                        Process{' '}
                                    </p>
                                    <p className={cn(styles.simpleProcess4Mobile, styles.showLP)}>
                                        Our Simple
                                        <span className={styles.gradientTextMobile}>
                                            {' '}
                                            4 Step
                                        </span>{' '}
                                        Visa Process{' '}
                                    </p>
                                    <span className={styles.showLP}>
                                        <HowItWorksButton onClick={openCloseVideoModal} />
                                    </span>
                                    <img
                                        src={fourStepProcessMobile}
                                        alt="Four Step Process"
                                        className={cn(styles.fourStepProcessMobile, styles.showLP)}
                                    />
                                    <img
                                        src={fourStepProcess}
                                        alt="Four Step Process"
                                        className={cn(styles.FourStepProcess, styles.hideLP)}
                                    />
                                    <span className={styles.hideLP}>
                                        <HowItWorksButton onClick={openCloseVideoModal} />
                                    </span>
                                </div>
                                <span className={styles.showLP}>
                                    <Certificates />
                                </span>

                                <SupportSection />
                                <Disclaimer />
                            </>
                        )}
                    </div>
                </div>
            </div>

            {mobile && !display && <Footer activateActionButton={actionButton} />}
        </>
    );
}
